export const PrimerIcon: React.FC<React.ComponentProps<"svg">> = ({
  ...props
}) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="28" height="28" fill="#FF8C78" />
      <g clipPath="url(#clip0_816_29631)">
        <path
          d="M18.8306 10.4137H15.9399C15.1186 10.4137 14.4506 9.76972 14.4506 8.97372V7.87239C14.4506 6.46839 13.2746 5.33105 11.8239 5.33105C10.3733 5.33105 9.19727 6.46839 9.19727 7.87239C9.19727 9.27639 10.3733 10.4137 11.8239 10.4137H12.9626C13.7839 10.4137 14.4519 11.0591 14.4519 11.8537V14.4791C14.4519 15.2737 13.7853 15.9191 12.9626 15.9191H11.8239C10.3733 15.9191 9.19727 17.0564 9.19727 18.4604V20.2991C9.19727 21.7031 10.3733 22.8404 11.8239 22.8404C13.2746 22.8404 14.4506 21.7031 14.4506 20.2991V17.3591C14.4506 16.5644 15.1159 15.9191 15.9399 15.9191H18.8293C19.3119 15.9191 19.7039 15.5404 19.7039 15.0724V11.2617C19.7039 10.7937 19.3133 10.4151 18.8306 10.4151V10.4137Z"
          fill="#1B1A1A"
        />
      </g>
      <defs>
        <clipPath id="clip0_816_29631">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(4 4)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
